export default __webpack_public_path__ + "static/media/oriaku.47410bf7.jpeg";